<div class="product-switch-cool-off-container overlay-content">
    <div class="product-switch-cool-off-title" [vnDynamicHtml]="title()"></div>
    <div class="product-switch-cool-off-text" [vnDynamicHtml]="text()"></div>
    <div class="product-switch-cool-off-actions">
        <button ds-button kind="primary" variant="filled" size="large" (click)="confirm()">{{ content().messages?.OKButton }}</button>
    </div>
</div>
